


















































































































import {
  typeNuevosCampo,
  typeTipoCampo,
} from '@/pantallas/ConfigurarBase/ConfiguracionBase';
import {
  emitFormChangeEvent,
  formErrors,
  FormFieldDefMap,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import GuardarButton from '@/reusable/Modal/GuardarButton.vue';
import GuardarCambiosButton from '@/reusable/Modal/GuardarCambiosButton.vue';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    CabeceraModal,
    GuardarButton,
    GuardarCambiosButton,
    ModalMantenedor,
    Confirmation,
    ContenidoModal,
  },
})
export default class CrearCampoDatosModal extends Vue {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: false }) modoEditar: boolean;
  @Prop() lstTipoDato: typeTipoCampo;
  @Prop() campoSeleccionado: typeNuevosCampo;

  titulo: string = 'Agregar Campos de Datos';
  dialogConfirmacionGuardar: boolean = false;
  dialogConfirmacionGuardarEditar: boolean = false;

  formFields: FormFieldDefMap = {
    codigo: {
      label: 'Código',
      id: 'codigo',
      value: '',
    },
    tipo: {
      label: 'Tipo de dato',
      id: 'tipo',
      value: '',
    },
    requerido: {
      label: 'Campo requerido',
      id: 'requerido',
      value: false,
    },
    descripcion: {
      label: 'Descripción',
      id: 'descripcion',
      value: '',
    },
    regExp: {
      label: 'Expresión regular',
      id: 'regExp',
      value: '',
    },
    mensajeError: {
      label: 'Mensaje error',
      id: 'mensajeError',
      value: '',
    },
  };

  mounted() {
    this.$validator.localize('es', makeValidatorDictionary(this.formFields));
  }

  handleCerrar() {
    this.formFields.codigo.value = '';
    this.formFields.tipo.value = '';
    this.formFields.descripcion.value = '';
    this.formFields.regExp.value = '';
    this.formFields.requerido.value = false;
    this.$emit('cerrar');
  }

  @Watch('modoEditar', { deep: true })
  handleModoEditarChange() {
    this.titulo = !this.modoEditar
      ? 'Agregar Campos de Datos'
      : 'Editar Campos de Datos: ';
  }

  @Watch('campoSeleccionado', { deep: true })
  handleCampoSeleccionadoChange() {
    if (this.campoSeleccionado) {
      this.formFields.codigo.value = this.campoSeleccionado.codigoCampo;
      this.formFields.tipo.value = this.campoSeleccionado.tipoCampo;
      this.formFields.descripcion.value = this.campoSeleccionado.descripcionCampo;
      this.formFields.regExp.value = this.campoSeleccionado.regExp;
      this.formFields.requerido.value = this.campoSeleccionado.requerido;
      this.formFields.mensajeError.value = this.campoSeleccionado.mensajeErrorFormato;
      this.titulo += this.modoEditar ? this.campoSeleccionado.codigoCampo : '';
    }
  }

  async handleGuardar() {
    const isValid = await this.$validator.validateAll();

    if (isValid) {
      if (!this.modoEditar) {
        this.dialogConfirmacionGuardar = true;
      } else {
        this.dialogConfirmacionGuardarEditar = true;
      }
    }
  }

  async confirmCallback(val: boolean) {
    this.dialogConfirmacionGuardar = false;
    this.dialogConfirmacionGuardarEditar = false;

    if (val) {
      var nuevoCampo: typeNuevosCampo = {
        codigoCampo: this.formFields.codigo.value.toString(),
        tipoCampo: Number(this.formFields.tipo.value.toString()),
        descripcionCampo: this.formFields.descripcion.value.toString(),
        regExp: this.formFields.regExp.value.toString(),
        requerido: Boolean(this.formFields.requerido.value),
        mensajeErrorFormato: this.formFields.mensajeError.value.toString(),
      };

      if (!this.modoEditar) {
        this.$emit('crear', nuevoCampo);
      } else {
        this.$emit('editar', nuevoCampo);
      }

      this.handleCerrar();
    }
  }
}
